var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 575.522,
    height: 256.649,
    viewBox: "0 0 575.522 256.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustra",
    transform: "translate(-672.239 -411.751)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 5.023,
    cy: 5.023,
    r: 5.023,
    transform: "translate(1064.218 510.934)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    cx: 6.14,
    cy: 6.14,
    r: 6.14,
    transform: "translate(880.374 641.381)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_20",
    "data-name": "Elipse 20",
    cx: 3.349,
    cy: 3.349,
    r: 3.349,
    transform: "translate(1027.885 461.444)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Porta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M1119.185,491.963l-31.67,41.256-64.509,84.041-38.514,50.172L948.526,666.1l-73.487-2.734-35.766-1.334L973.959,486.56Z",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M854.88,662.3,981.344,498.725l128.558,4.863",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_39",
    "data-name": "Linha 39",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(974.1 486.795)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_40",
    "data-name": "Linha 40",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(978.683 487.039)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_41",
    "data-name": "Linha 41",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(983.266 487.266)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_42",
    "data-name": "Linha 42",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(987.849 487.494)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_43",
    "data-name": "Linha 43",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(992.432 487.722)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_44",
    "data-name": "Linha 44",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(997.015 487.949)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_45",
    "data-name": "Linha 45",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1001.597 488.177)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_46",
    "data-name": "Linha 46",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1006.18 488.404)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_47",
    "data-name": "Linha 47",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1010.763 488.632)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_48",
    "data-name": "Linha 48",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1015.346 488.859)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_49",
    "data-name": "Linha 49",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1019.929 489.087)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_50",
    "data-name": "Linha 50",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1024.511 489.315)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_51",
    "data-name": "Linha 51",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1029.061 488.897)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_52",
    "data-name": "Linha 52",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1033.644 489.125)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_53",
    "data-name": "Linha 53",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1038.226 489.352)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_54",
    "data-name": "Linha 54",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1042.809 489.58)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_55",
    "data-name": "Linha 55",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1047.392 489.808)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_56",
    "data-name": "Linha 56",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1051.975 490.035)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_57",
    "data-name": "Linha 57",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1056.524 489.618)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_58",
    "data-name": "Linha 58",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1061.107 489.845)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_59",
    "data-name": "Linha 59",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1065.69 490.073)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_60",
    "data-name": "Linha 60",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1070.273 490.301)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_61",
    "data-name": "Linha 61",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1074.856 490.528)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_62",
    "data-name": "Linha 62",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1079.438 490.756)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_63",
    "data-name": "Linha 63",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1084.021 490.983)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_64",
    "data-name": "Linha 64",
    x2: 6.719,
    y2: 11.065,
    transform: "translate(1088.955 491.198)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_65",
    "data-name": "Linha 65",
    x2: 6.901,
    y2: 11.365,
    transform: "translate(1093.355 491.126)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_66",
    "data-name": "Linha 66",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1097.76 491.485)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_67",
    "data-name": "Linha 67",
    x2: 7.103,
    y2: 11.697,
    transform: "translate(1102.343 491.713)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_68",
    "data-name": "Linha 68",
    x2: 5.086,
    y2: 8.376,
    transform: "translate(1106.926 491.94)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_69",
    "data-name": "Linha 69",
    x2: 3.148,
    y2: 5.184,
    transform: "translate(1111.509 492.168)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_70",
    "data-name": "Linha 70",
    x2: 0.7,
    y2: 1.153,
    transform: "translate(1116.072 492.01)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_71",
    "data-name": "Linha 71",
    x1: 131.925,
    y2: 171.803,
    transform: "translate(843.362 490.092)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_72",
    "data-name": "Linha 72",
    x1: 129.538,
    y2: 168.695,
    transform: "translate(847.287 493.309)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_73",
    "data-name": "Linha 73",
    x1: 127.196,
    y2: 165.646,
    transform: "translate(851.391 496.569)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.937
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M848.424,624.064H813.965v44.185H778.95V624.064H672.239v-25.01l95.874-125.331h38.626L716.425,593.5h63.637V554.313h33.9V593.5h34.459Z",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_0",
    "data-name": 0,
    d: "M1073.381,551.634l-88.89,115.8-29.52-1.1a98.1,98.1,0,1,1,118.41-114.7Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_4-2",
    "data-name": 4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M1247.761,624.064H1213.3v44.185h-35.015V624.064H1071.576v-25.01l95.873-125.331h38.627L1115.762,593.5H1179.4V554.313h33.9V593.5h34.459Z",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("g", {
    id: "erro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M786.22,421.141H773.651c.45,2.339,2.4,3.839,5.19,3.839a5.742,5.742,0,0,0,4.35-1.74l2.009,2.311a8.123,8.123,0,0,1-6.45,2.609c-5.369,0-8.849-3.45-8.849-8.22a7.966,7.966,0,0,1,8.28-8.189c4.68,0,8.1,3.27,8.1,8.279C786.28,420.33,786.25,420.78,786.22,421.141Zm-12.6-2.491h9.09a4.36,4.36,0,0,0-4.529-3.9A4.428,4.428,0,0,0,773.62,418.65Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M799.151,411.751v3.569a4.85,4.85,0,0,0-.871-.09c-2.849,0-4.649,1.68-4.649,4.951v7.769h-3.75V411.931h3.569v2.34C794.53,412.591,796.481,411.751,799.151,411.751Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M811.6,411.751v3.569a4.849,4.849,0,0,0-.87-.09c-2.85,0-4.65,1.68-4.65,4.951v7.769h-3.75V411.931h3.57v2.34C806.981,412.591,808.931,411.751,811.6,411.751Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M813.311,419.94c0-4.8,3.6-8.189,8.519-8.189,4.981,0,8.55,3.39,8.55,8.189s-3.569,8.22-8.55,8.22C816.911,428.16,813.311,424.74,813.311,419.94Zm13.29,0a4.761,4.761,0,1,0-4.771,5.01A4.666,4.666,0,0,0,826.6,419.94Z",
    fill: "#292929"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.06cc045c406e1b3e49446bc306230ffd.svg";
export { ForwardRef as ReactComponent };